import React from "react";
import { Typography } from "@mui/material";

import EmailSentPic from "assets/images/email-share-modal/email-sent.png";

import useStyles from "./useStyles";

const SuccessScheduled = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h1" align="center" className={classes.title}>
        Email Scheduled!
      </Typography>
      <img src={EmailSentPic} alt="Email sent" className={classes.image} />
      <Typography variant="large" align="center">
        Sending a smile at that specified time.
      </Typography>
    </div>
  );
};

export default SuccessScheduled;
